<!-- 产品模板 -->
<template>
    <div class="container">
            <div v-if="dataTable.length > 0" class="template-card">
                <div class="card-preview">
                    <img v-if="dataTable[0].cover_img" class="preview-img" :src="dataTable[0].cover_img" />
                    <div v-else class="preview-placeholder">暂无预览图</div>
                </div>
                <div class="card-info">
                    <div class="info-item">
                        <span class="label">模板名称：</span>
                        <span class="value">{{ dataTable[0].title }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">创建时间：</span>
                        <span class="value">{{ dataTable[0].handle_time }}</span>
                    </div>
                    <div class="card-actions">
                        <Button type="primary" ghost @click="goCopy(dataTable[0])">复制</Button>
                    </div>
                </div>
            </div>
            <div v-else class="empty-state">
                <Icon type="md-document" size="48" color="#ccc" />
                <p>暂无数据</p>
            </div>
            <!-- 复制模板 -->
            <Modal
                v-model="copyModal"
                title="复制模板"
                :width="400"
                :mask-closable="false"
            >
                <div>
                    <Form
                        :model="formItem"
                        label-position="right"
                        :label-width="100"
                    >
                        <FormItem label="模板名称">
                            <Input
                                class="w15"
                                type="text"
                                style="width:200px"
                                v-model="formItem.title"
                                placeholder="请输入模板名称"
                            ></Input>
                            <Tooltip
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p theme-color"
                                    type="md-help-circle"
                                    size="20"
                                />
                                <div slot="content">
                                    <p>此模板将会复制到DIY模板内！</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Form>
                </div>
                <div slot="footer">
                    <Button @click="cancelCopyModal">取消</Button>
                    <Button
                        class="theme-bc theme-default-color"
                        @click="submitCopyModal"
                        >确定</Button
                    >
                </div>
            </Modal>
    </div>
</template>

<script>
import {
    template_result_template,
    template_copy_result,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            dataTable: [],
            copyModal: false,
            formItem: {
                title: "",
                id: "",
            },
        };
    },
    mounted() {
        this.dataTable = [];
        this.getList();
    },
    methods: {
        getList() {
            template_result_template(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goCopy(row) {
            this.formItem.id = row.id;
            this.formItem.title = row.title;
            this.copyModal = true;
        },
        // 取消
        cancelCopyModal() {
            this.copyModal = false;
        },
        // 确定
        submitCopyModal() {
            template_copy_result(this.formItem)
                .then((res) => {
                    this.getList();
                    this.copyModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        }
    },
};
</script>

<style scoped>
.container {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.template-card {
    display: flex;
    gap: 24px;
    padding: 24px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    max-width: 600px;
}
.card-preview {
    width: 120px;
    height: 180px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
}
.preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.preview-placeholder {
    color: #94a3b8;
    font-size: 12px;
}
.card-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
}
.info-item {
    display: flex;
    align-items: center;
}
.label {
    color: #64748b;
    font-size: 14px;
}
.value {
    color: #0f172a;
    font-size: 14px;
    font-weight: 500;
}
.card-actions {
    display: flex;
    gap: 12px;
    margin-top: 8px;
}
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px;
    color: #94a3b8;
}
.empty-state p {
    margin-top: 12px;
}
.w15 {
    width: 15vw;
}
.cursor-p {
    cursor: pointer;
}
::v-deep .ivu-form-item {
    margin-bottom: 0;
}
</style>